import { AudioDropZone } from '@/components/home/audio-drop-zone';
import { TemplateList } from '@/components/home/template-list';

export const Home = () => {
  return (
    <AudioDropZone>
      <TemplateList />
    </AudioDropZone>
  );
};
